"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Pill_meta_1 = require("./Pill.meta");

var Translate_1 = __importDefault(require("../Translate"));

var Value_1 = __importDefault(require("./styledComponents/Value"));

var Icon_1 = __importDefault(require("../Icon/Icon"));

var Translate_2 = require("../Translate/Translate");

var mobx_1 = require("mobx");

var Pill = function (_super) {
  __extends(Pill, _super);

  function Pill(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Pill_meta_1.PILL_CATEGORY_KEY;
    _this.componentKey = Pill_meta_1.PILL_COMPONENT_KEY;
    return _this;
  }

  Object.defineProperty(Pill.prototype, "ariaLabel", {
    get: function get() {
      var _a = this.props,
          label = _a.label,
          value = _a.value,
          children = _a.children;
      var labelText = label + " " + (value || children);

      if (this.translationContext) {
        var translatedLabel = label && this.translationContext.translate(label);
        var translatedValue = '';

        if (value) {
          translatedValue = this.translationContext.translate(value);
        } else if (children) {
          translatedValue = this.translationContext.translate(children);
        }

        labelText = (translatedLabel || '') + " " + translatedValue;
      }

      return labelText;
    },
    enumerable: true,
    configurable: true
  });

  Pill.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        children = _a.children,
        value = _a.value,
        icon = _a.icon,
        _b = _a.iconPosition,
        iconPosition = _b === void 0 ? 'left' : _b,
        onClick = _a.onClick,
        onKeyDown = _a.onKeyDown,
        label = _a.label;
    var pillIcon = react_1.default.createElement(Icon_1.default, __assign({}, icon, {
      "aria-hidden": true
    }));
    return react_1.default.createElement(Translate_2.TranslationContext.Consumer, null, function (translationContext) {
      _this.translationContext = translationContext;
      return react_1.default.createElement(Wrapper_1.default, {
        className: className,
        onClick: onClick,
        onKeyDown: onKeyDown,
        "aria-label": _this.ariaLabel,
        role: 'text'
      }, icon && iconPosition === 'left' && pillIcon, react_1.default.createElement(Value_1.default, null, react_1.default.createElement(Translate_1.default, null, value || children)), icon && iconPosition === 'right' && pillIcon);
    });
  };

  __decorate([mobx_1.computed], Pill.prototype, "ariaLabel", null);

  Pill = __decorate([mobx_react_1.observer], Pill);
  return Pill;
}(shared_1.ComponentBase);

exports.Pill = Pill;
exports.default = shared_1.InjectedStyledComponent(Pill, Pill_meta_1.PILL_CATEGORY_KEY, Pill_meta_1.PILL_COMPONENT_KEY);